import React from 'react';

function UnpublishIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      viewBox="0 0 16 16"
      className={className}
    >
      <path
        d="M8.393,8.169 C8.202,7.954 7.834,7.954 7.643,8.169 L5.875,10.169 C5.692,10.376 5.712,10.691 5.919,10.875 C6.124,11.057 6.44,11.039 6.625,10.831 L7.518,9.821 L7.518,15.5 C7.518,15.776 7.742,16 8.018,16 C8.294,16 8.518,15.776 8.518,15.5 L8.518,9.821 L9.411,10.831 C9.51,10.943 9.647,11 9.785,11 C9.903,11 10.021,10.959 10.116,10.875 C10.323,10.691 10.343,10.376 10.16,10.169 L8.393,8.169 Z"
      />
      <path
        d="M8,0 C3.589,0 0,3.589 0,8 C0,9.972 0.724,11.865 2.036,13.333 C2.222,13.539 2.538,13.556 2.742,13.373 C2.948,13.188 2.966,12.872 2.782,12.667 C1.633,11.383 1,9.726 1,8 C1,4.141 4.141,1 8,1 C11.859,1 15,4.141 15,8 C15,9.726 14.367,11.383 13.218,12.666 C13.072,12.829 12.919,12.984 12.759,13.133 C12.557,13.321 12.544,13.637 12.732,13.84 C12.83,13.946 12.964,14 13.099,14 C13.221,14 13.342,13.956 13.439,13.867 C13.623,13.697 13.797,13.518 13.963,13.333 C15.276,11.866 16,9.972 16,8 C16,3.589 12.411,0 8,0 Z"
      />
    </svg>
  );
}

export default UnpublishIcon;
